import React from 'react';
import { useParams } from 'react-router-dom';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { servicesContent } from '../data/servicesData';

const ServicePage = () => {
  const { slug } = useParams();
  const pageData = servicesContent[slug];

  return <ServicePageTemplate pageData={pageData} />;
};

export default ServicePage;
